<!-- Detail Modal -->
<ng-template #detailModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title font-weight-bold">{{ "Comparison Detail" | translate }}</h5>
    <button type="button" class="close" (click)="modal.dismiss()">
      <span>&times;</span>
    </button>
  </div>
  <div class="modal-body detail-modal-body p-0">

    <!-- Loading -->
    <div class="text-center py-5" *ngIf="isLoadingDetail">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted small">{{ "Loading..." | translate }}</p>
    </div>

    <div *ngIf="!isLoadingDetail && detail">

      <!-- Plan Progress -->
      <div *ngIf="isApply == 1 && planProgress" class="plan-progress-wrap px-4 pt-3 pb-3">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <span class="font-weight-bold small">{{ "Plan Progress" | translate }}</span>
          <span class="small text-muted">{{ planProgress.done }} / {{ planProgress.total }} {{ "Tasks Done" | translate }}</span>
        </div>
        <div class="progress" style="height: 8px;">
          <div class="progress-bar bg-success" role="progressbar"
            [style.width.%]="planProgress.total > 0 ? (planProgress.done / planProgress.total * 100) : 0">
          </div>
        </div>
        <div class="d-flex justify-content-between mt-1">
          <small class="text-muted">{{ planProgress.pending }} {{ "pending" | translate }}</small>
          <small class="text-success font-weight-bold" *ngIf="planProgress.is_complete">{{ "Complete" | translate }} ✓</small>
        </div>
      </div>

      <div class="detail-content px-4 py-4">

        <!-- Summary Banner -->
        <div class="summary-banner mb-4">
          <i class="fi fi-rr-document-signed banner-icon"></i>
          <p class="mb-0">{{ detail.summary }}</p>
        </div>

        <!-- Score Cards -->
        <div class="row mb-4">
          <div class="col-md-6 mb-3 mb-md-0">
            <div class="score-card score-dealer">
              <div class="score-label">{{ "Your Page" | translate }}</div>
              <div class="score-number">{{ detail.overall_score?.dealer }}<span class="score-denom">/10</span></div>
              <div class="score-bar">
                <div class="score-fill" [style.width.%]="detail.overall_score?.dealer ? detail.overall_score.dealer * 10 : 0"></div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="score-card score-competitor">
              <div class="score-label">{{ "Competitor" | translate }}</div>
              <div class="score-number">{{ detail.overall_score?.competitor }}<span class="score-denom">/10</span></div>
              <div class="score-bar">
                <div class="score-fill" [style.width.%]="detail.overall_score?.competitor ? detail.overall_score.competitor * 10 : 0"></div>
              </div>
            </div>
          </div>
          <div class="col-12 mt-2" *ngIf="detail.overall_score?.verdict">
            <p class="verdict-text">{{ detail.overall_score?.verdict }}</p>
          </div>
        </div>

        <!-- Your Page vs Competitor -->
        <div class="row mb-4" *ngIf="detail.dealer_strengths?.length || detail.dealer_weaknesses?.length || detail.competitor_strengths?.length || detail.competitor_weaknesses?.length">
          <div class="col-md-6 mb-3 mb-md-0">
            <div class="sw-card">
              <div class="sw-card-header dealer-header">
                <i class="fi fi-rr-user mr-2"></i>{{ "Your Page" | translate }}
              </div>
              <div class="sw-card-body">
                <div *ngIf="detail.dealer_strengths?.length" class="mb-3">
                  <div class="sw-section-label strengths-label"><i class="fi fi-rr-check-circle mr-1"></i>{{ "Strengths" | translate }}</div>
                  <div *ngFor="let s of detail.dealer_strengths" class="sw-item strength-item">
                    <i class="fi fi-rr-check mr-2 flex-shrink-0"></i><span>{{ s }}</span>
                  </div>
                </div>
                <div *ngIf="detail.dealer_weaknesses?.length">
                  <div class="sw-section-label weaknesses-label"><i class="fi fi-rr-cross-circle mr-1"></i>{{ "Weaknesses" | translate }}</div>
                  <div *ngFor="let s of detail.dealer_weaknesses" class="sw-item weakness-item">
                    <i class="fi fi-rr-cross mr-2 flex-shrink-0"></i><span>{{ s }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="sw-card">
              <div class="sw-card-header competitor-header">
                <i class="fi fi-rr-users mr-2"></i>{{ "Competitor" | translate }}
              </div>
              <div class="sw-card-body">
                <div *ngIf="detail.competitor_strengths?.length" class="mb-3">
                  <div class="sw-section-label strengths-label"><i class="fi fi-rr-check-circle mr-1"></i>{{ "Strengths" | translate }}</div>
                  <div *ngFor="let s of detail.competitor_strengths" class="sw-item strength-item">
                    <i class="fi fi-rr-check mr-2 flex-shrink-0"></i><span>{{ s }}</span>
                  </div>
                </div>
                <div *ngIf="detail.competitor_weaknesses?.length">
                  <div class="sw-section-label weaknesses-label"><i class="fi fi-rr-cross-circle mr-1"></i>{{ "Weaknesses" | translate }}</div>
                  <div *ngFor="let s of detail.competitor_weaknesses" class="sw-item weakness-item">
                    <i class="fi fi-rr-cross mr-2 flex-shrink-0"></i><span>{{ s }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Detailed Analysis -->
        <div class="mb-4" *ngIf="detail.above_fold_analysis || detail.readability">
          <div class="detail-section-title"><i class="fi fi-rr-chart-histogram mr-2"></i>{{ "Detailed Analysis" | translate }}</div>
          <div class="row">
            <div class="col-md-6 mb-3" *ngIf="detail.above_fold_analysis">
              <div class="analysis-card">
                <div class="analysis-card-title">{{ "Above Fold" | translate }}</div>
                <div class="analysis-row">
                  <span class="analysis-label dealer-label">{{ "Your Page" | translate }}</span>
                  <p class="mb-0">{{ detail.above_fold_analysis.dealer }}</p>
                </div>
                <div class="analysis-row">
                  <span class="analysis-label competitor-label">{{ "Competitor" | translate }}</span>
                  <p class="mb-0">{{ detail.above_fold_analysis.competitor }}</p>
                </div>
                <div class="analysis-verdict" *ngIf="detail.above_fold_analysis.verdict">
                  <i class="fi fi-rr-bulb mr-1"></i>{{ detail.above_fold_analysis.verdict }}
                </div>
              </div>
            </div>
            <div class="col-md-6 mb-3" *ngIf="detail.readability">
              <div class="analysis-card">
                <div class="analysis-card-title">{{ "Readability" | translate }}</div>
                <div class="analysis-row">
                  <span class="analysis-label dealer-label">{{ "Your Page" | translate }} <span class="score-pill">{{ detail.readability.dealer?.score }}</span></span>
                  <p class="mb-0">{{ detail.readability.dealer?.assessment }}</p>
                </div>
                <div class="analysis-row">
                  <span class="analysis-label competitor-label">{{ "Competitor" | translate }} <span class="score-pill">{{ detail.readability.competitor?.score }}</span></span>
                  <p class="mb-0">{{ detail.readability.competitor?.assessment }}</p>
                </div>
                <div class="analysis-verdict" *ngIf="detail.readability.recommendation">
                  <i class="fi fi-rr-bulb mr-1"></i>{{ detail.readability.recommendation }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Recommendations -->
        <div class="mb-4" *ngIf="detail.missing_sections?.length || detail.quick_wins?.length || detail.critics?.length">
          <div class="detail-section-title"><i class="fi fi-rr-lightbulb-on mr-2"></i>{{ "Recommendations" | translate }}</div>
          <div class="row">
            <div class="col-md-4 mb-3" *ngIf="detail.missing_sections?.length">
              <div class="reco-card reco-missing">
                <div class="reco-card-title"><i class="fi fi-rr-puzzle-piece mr-2"></i>{{ "Missing Sections" | translate }}</div>
                <div *ngFor="let s of detail.missing_sections" class="reco-item">{{ s }}</div>
              </div>
            </div>
            <div class="col-md-4 mb-3" *ngIf="detail.quick_wins?.length">
              <div class="reco-card reco-wins">
                <div class="reco-card-title"><i class="fi fi-rr-rocket mr-2"></i>{{ "Quick Wins" | translate }}</div>
                <div *ngFor="let s of detail.quick_wins" class="reco-item">{{ s }}</div>
              </div>
            </div>
            <div class="col-md-4 mb-3" *ngIf="detail.critics?.length">
              <div class="reco-card reco-critics">
                <div class="reco-card-title"><i class="fi fi-rr-exclamation mr-2"></i>{{ "Critics" | translate }}</div>
                <div *ngFor="let s of detail.critics" class="reco-item">{{ s }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Improvements -->
        <div class="mb-4" *ngIf="detail.improvements?.length">
          <div class="detail-section-title"><i class="fi fi-rr-arrow-trend-up mr-2"></i>{{ "Improvements" | translate }}</div>
          <div class="improvement-card" *ngFor="let item of detail.improvements">
            <div class="improvement-header">
              <strong>{{ item.area }}</strong>
              <span class="priority-badge"
                [class.priority-high]="item.priority === 'high'"
                [class.priority-medium]="item.priority === 'medium'"
                [class.priority-low]="item.priority === 'low'">
                {{ item.priority }}
              </span>
            </div>
            <div *ngIf="item.current" class="improvement-row">
              <span class="improvement-label">{{ "Current" | translate }}</span>
              <span>{{ item.current }}</span>
            </div>
            <div class="improvement-row">
              <span class="improvement-label">{{ "Suggestion" | translate }}</span>
              <span>{{ item.suggestion }}</span>
            </div>
            <div class="improvement-reason" *ngIf="item.reason">{{ item.reason }}</div>
          </div>
        </div>

        <!-- Rewritten Copy -->
        <div class="mb-4" *ngIf="detail.rewritten_copy">
          <div class="detail-section-title"><i class="fi fi-rr-pen-field mr-2"></i>{{ "Rewritten Copy" | translate }}</div>
          <div class="rewritten-copy-card">
            <div class="copy-row">
              <span class="copy-label">{{ "Headline" | translate }}</span>
              <span class="copy-value">{{ detail.rewritten_copy.headline }}</span>
            </div>
            <div class="copy-row">
              <span class="copy-label">{{ "Subheadline" | translate }}</span>
              <span class="copy-value">{{ detail.rewritten_copy.subheadline }}</span>
            </div>
            <div class="copy-row">
              <span class="copy-label">{{ "CTA" | translate }}</span>
              <span class="copy-value cta-value">{{ detail.rewritten_copy.cta }}</span>
            </div>
          </div>
        </div>

        <!-- Action Plan -->
        <div *ngIf="detail.action_plan">
          <div class="detail-section-title"><i class="fi fi-rr-calendar-check mr-2"></i>{{ "Action Plan" | translate }}</div>
          <div *ngFor="let phase of getActionPlanPhases(detail.action_plan)" class="mb-3">
            <div class="phase-toggle" (click)="togglePhase(phase.key)">
              <strong>{{ phase.label }}</strong>
              <i class="fi ml-2" [class.fi-rr-angle-down]="!actionPlanOpen[phase.key]" [class.fi-rr-angle-up]="actionPlanOpen[phase.key]"></i>
            </div>
            <div *ngIf="actionPlanOpen[phase.key]">
              <table class="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th style="width: 60px;">{{ "Day" | translate }}</th>
                    <th>{{ "Content" | translate }}</th>
                    <th *ngIf="sameStore && isApply !== 10" style="width: 70px;" class="text-center">{{ "Edit" | translate }}</th>
                    <th *ngIf="isApply == 2" style="width: 100px;" class="text-center">{{ "Apply Changes" | translate }}</th>
                    <th *ngIf="isApply == 1 || isApply == 10" style="width: 100px;" class="text-center">{{ "Skip Apply Changes" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of phase.items">
                    <td class="text-center align-middle"><strong>{{ item.day }}</strong></td>
                    <td class="align-middle">
                      <div>{{ item.description }}</div>
                      <div class="text-muted small mt-1">{{ item.target }} &nbsp;|&nbsp; {{ item.type }}</div>
                      <div *ngIf="item.new_content" class="mt-1 text-primary small">{{ item.new_content }}</div>
                    </td>
                    <ng-container *ngIf="(isApply == 2 && item.status == 1) || (isApply == 1 && item.status == 11); else splitCols">
                      <td colspan="2" class="text-center align-middle">
                        <span *ngIf="isApply == 2 && item.status == 1" class="badge badge-success">{{ "Applied Changes" | translate }}</span>
                        <div *ngIf="isApply == 1 && item.status == 11" class="d-flex flex-column align-items-center">
                          <span class="badge badge-danger mb-1">{{ "Insufficient Credit" | translate }}</span>
                          <button type="button" class="btn btn-sm btn-primary" (click)="onRetryDay(item)" [disabled]="item._retrying">
                            <span *ngIf="item._retrying" class="spinner-border spinner-border-sm" role="status"></span>
                            <span *ngIf="!item._retrying">{{ "Reapply" | translate }}</span>
                          </button>
                        </div>
                      </td>
                    </ng-container>
                    <ng-template #splitCols>
                      <ng-container *ngIf="isApply == 1 && sameStore && (item.status == 1 || item.status == 9); else activeCols">
                        <td colspan="2" class="text-center align-middle">
                          <span *ngIf="item.status == 1" class="badge badge-success">{{ "Applied Changes" | translate }}</span>
                          <span *ngIf="item.status == 9" class="badge badge-warning">{{ "Skipped" | translate }}</span>
                        </td>
                      </ng-container>
                      <ng-template #activeCols>
                        <td *ngIf="sameStore && isApply !== 10" class="text-center align-middle">
                          <button *ngIf="item.status == 0" type="button" class="btn btn-sm btn-outline-secondary" (click)="openEditPlan(item)">
                            <i class="fi fi-rr-pencil"></i>
                          </button>
                        </td>
                        <td *ngIf="isApply == 2" class="text-center align-middle">
                          <button *ngIf="item.status == 0" type="button" class="btn btn-sm btn-primary" (click)="onApplyPlanItem(item)" [disabled]="item._applying">
                            <span *ngIf="item._applying" class="spinner-border spinner-border-sm" role="status"></span>
                            <span *ngIf="!item._applying">{{ "Apply" | translate }}</span>
                          </button>
                        </td>
                        <td *ngIf="isApply == 1 || isApply == 10" class="text-center align-middle">
                          <button *ngIf="item.status == 0" type="button" class="btn btn-sm btn-outline-danger" (click)="onSkipPlanItem(item)" [disabled]="item._skipping">
                            <span *ngIf="item._skipping" class="spinner-border spinner-border-sm" role="status"></span>
                            <span *ngIf="!item._skipping">{{ "Skip" | translate }}</span>
                          </button>
                          <span *ngIf="!sameStore && isApply == 1 && item.status == 9" class="badge badge-warning">{{ "Skipped" | translate }}</span>
                          <span *ngIf="isApply == 10 && item.status == 10" class="badge badge-danger">{{ "Stopped" | translate }}</span>
                          <span *ngIf="isApply == 10 && item.status == 1" class="badge badge-success">{{ "Applied Changes" | translate }}</span>
                          <span *ngIf="isApply == 10 && item.status == 9" class="badge badge-warning">{{ "Skipped" | translate }}</span>
                        </td>
                      </ng-template>
                    </ng-template>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
  <div class="modal-footer" *ngIf="!isLoadingDetail && (showApplyButton || isApply == 1)">
    <button *ngIf="showApplyButton" class="btn btn-outline-primary mr-2" (click)="onApply(2)" [disabled]="isApplying">
      <span *ngIf="isApplying && applyingType === 2" class="spinner-border spinner-border-sm mr-1" role="status"></span>
      {{ "Manual Apply" | translate }}
    </button>
    <button *ngIf="showApplyButton" class="btn btn-primary mr-2" (click)="onApply(1)" [disabled]="isApplying">
      <span *ngIf="isApplying && applyingType === 1" class="spinner-border spinner-border-sm mr-1" role="status"></span>
      {{ "Auto Apply" | translate }}
    </button>
    <button *ngIf="isApply == 1" class="btn btn-danger" (click)="onStopPlan()" [disabled]="isStoppingPlan">
      <span *ngIf="isStoppingPlan" class="spinner-border spinner-border-sm mr-1" role="status"></span>
      {{ "Stop Auto Apply" | translate }}
    </button>
  </div>
</ng-template>

<!-- Edit Action Plan Modal -->
<ng-template #editPlanModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title font-weight-bold">{{ "Edit Action Plan" | translate }} — {{ "Day" | translate }} {{ editPlanItem?.day }}</h5>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <div class="form-group mb-0">
      <label class="font-weight-bold">{{ "Content" | translate }}</label>
      <textarea class="form-control mt-1" rows="4" [(ngModel)]="editPlanContent" [placeholder]="'Enter new content' | translate"></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" [disabled]="isUpdatingPlan">{{ "Cancel" | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="onUpdatePlan(modal)" [disabled]="isUpdatingPlan || !editPlanContent.trim()">
      <span *ngIf="isUpdatingPlan" class="spinner-border spinner-border-sm mr-1" role="status"></span>
      {{ "Update" | translate }}
    </button>
  </div>
</ng-template>

<div class="wrapper-ai-landing-page">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <a routerLink="/dashboard/overview" class="btn btn-back rounded-circle mt-2">
            <i class="fi-rr-arrow-alt-left"></i>
          </a>
          <div class="title">{{ "AI Landing Page" | translate }}</div>
        </div>
      </div>
      <div class="col text-right">
        <button class="btn btn-primary" (click)="goToCompare()">
          {{ "New Comparison" | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="section-main">

    <!-- Toolbar — hidden while loading or failed -->
    <div class="ai-lp-toolbar mb-4" *ngIf="!isLoading && !loadFailed">
      <div class="search-box">
        <i class="fi fi-rr-search search-icon"></i>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="searchTerm"
          placeholder="{{ 'Search by Own Page or Competitor URL' | translate }}..."
        />
        <button
          *ngIf="searchTerm"
          type="button"
          class="btn-clear-search"
          (click)="searchTerm = ''"
          aria-label="Clear search"
        >
          <i class="fi fi-rr-cross-small"></i>
        </button>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted">{{ "Retrieving...please wait" | translate }}</p>
    </div>

    <!-- Load failed -->
    <div class="warn-card mb-3" *ngIf="!isLoading && loadFailed">
      <i class="fi fi-rr-exclamation mr-2"></i>
      <span>{{ "We could not load the comparisons. Please try again." | translate }}</span>
      <button type="button" class="btn btn-retry ml-auto" (click)="loadList()">
        {{ "Retry" | translate }}
      </button>
    </div>

    <!-- Empty state -->
    <div class="empty-state text-center py-5" *ngIf="!isLoading && !loadFailed && historyList.length === 0">
      <i class="fi fi-rr-file-search empty-icon"></i>
      <p class="mt-3 text-muted">{{ "No comparisons yet. Click New Comparison to get started." | translate }}</p>
    </div>

    <!-- List -->
    <div *ngIf="!isLoading && !loadFailed && historyList.length > 0"
      class="table-history table-responsive mx-auto shadow-md rounded-md">
      <table class="table">
        <thead>
          <tr>
            <th class="text-start" scope="col">#</th>
            <th class="text-start" scope="col" style="min-width: 250px;">{{ "Landing Page" | translate }}</th>
            <th class="text-start" scope="col">{{ "Score" | translate }}</th>
            <th class="text-start" scope="col">{{ "Summary" | translate }}</th>
            <th class="text-center" scope="col">{{ "Apply AI" | translate }}</th>
            <th class="text-center" scope="col">{{ "Details" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredList; let i = index">
            <td class="text-start">{{ i + 1 }}</td>
            <td class="url-cell">
              <div class="url-group">
                <p class="url-group-label">{{ "Dealer" | translate }}</p>
                <a [href]="item.own_page_url" target="_blank" rel="noopener noreferrer" class="landing-link" [title]="item.own_page_url">
                  {{ displayUrl(item.own_page_url) }}
                  <i class="fi fi-rr-arrow-up-right ml-1 external-icon"></i>
                </a>
              </div>
              <div class="url-group">
                <p class="url-group-label">{{ "Competitor" | translate }}</p>
                <a [href]="item.competitor_url" target="_blank" rel="noopener noreferrer" class="landing-link" [title]="item.competitor_url">
                  {{ displayUrl(item.competitor_url) }}
                  <i class="fi fi-rr-arrow-up-right ml-1 external-icon"></i>
                </a>
              </div>
            </td>
            <td class="text-start">
              <div class="mb-1"><small class="text-muted">{{ "Dealer" | translate }}:</small><br>{{ item.overall_score_dealer }} / 10</div>
              <div><small class="text-muted">{{ "Competitor" | translate }}:</small><br>{{ item.overall_score_competitor }} / 10</div>
            </td>
            <td class="summary-cell">{{ item.summary }}</td>
            <td class="text-center">
              <span class="badge"
                [class.badge-secondary]="item.is_apply == 0"
                [class.badge-success]="item.is_apply == 1"
                [class.badge-info]="item.is_apply == 2"
                [class.badge-danger]="item.is_apply == 10">
                {{ item.is_apply == 1 ? ('Auto' | translate) : item.is_apply == 2 ? ('Manual' | translate) : item.is_apply == 10 ? ('Stop' | translate) : ('No' | translate) }}
              </span>
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn-styles rounded px-2 py-1 bg-white text-xs h-7 transition duration-300 ease drop-shadow-xs hover:drop-shadow !border border-gray-200 text-indigo-600 hover:!bg-indigo-50/[0.5] hover:!border-indigo-200"
                (click)="viewDetail(item.id)">
                <i class="fi fi-rs-eye mr-1"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- No search results -->
    <div class="empty-state text-center py-5" *ngIf="!isLoading && !loadFailed && historyList.length > 0 && filteredList.length === 0">
      <i class="fi fi-rr-search empty-icon"></i>
      <p class="mt-3 text-muted">{{ "No comparisons match your search." | translate }}</p>
    </div>

    <!-- Pagination -->
    <div class="row px-4 py-3" *ngIf="!isLoading && !loadFailed && historyList.length > 0">
      <div class="col">
        <ngb-pagination
          [collectionSize]="totalRecord"
          [(page)]="page"
          [pageSize]="pageSize"
          [maxSize]="5"
          [ellipses]="false"
          [rotate]="true"
          (pageChange)="changePage($event)">
        </ngb-pagination>
      </div>
      <div class="col text-right">
        <small class="text-muted">{{ "Showing" | translate }} <b>{{ (page - 1) * pageSize + 1 }}–{{ (page - 1) * pageSize + historyList.length }}</b> {{ "of" | translate }} <b>{{ totalRecord }}</b></small>
      </div>
    </div>

  </div>
</div>
